import React from "react";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { ACTIONS as CHAT_ACTIONS } from "../../redux/chat";
import StyledTestPage from "./styles";

const CONSTANTS = {
  chatId: "DXIlc6mlY1OGBJmkd5yPVRxT37A3_DiC13QQWkbUbte8VWvnmwZC96ml1",
};

const TestPage = () => {
  const dispatch = useDispatch();

  const createNewChat = () => {
    dispatch(CHAT_ACTIONS.initNewChat({ chatId: CONSTANTS.chatId }));
  };

  return (
    <StyledTestPage>
      <div className="test-page">
        <div className="button-container">
          <Button variant="contained" onClick={createNewChat}>
            Create chat
          </Button>
          <Button variant="contained">X</Button>
          <Button variant="contained">X</Button>
          <Button variant="contained">X</Button>
        </div>
      </div>
    </StyledTestPage>
  );
};

export default TestPage;
